var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.414,
    clipRule: "evenodd",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    x: 0.211,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M75.941,79.528c-11.617,10.144 -28.988,13.34 -43.601,7.365c-17.62,-7.204 -28.844,-27.468 -25.473,-46.322c3.373,-18.867 20.915,-34.128 40.531,-34.563c0.361,-0.006 0.722,-0.008 1.084,-0.007c19.279,0.183 37.454,15.06 41.025,34.312c2.394,12.904 -1.734,26.845 -10.689,36.433l34.787,33.82c0.746,0.788 0.617,1.05 0.605,1.489c-0.042,1.525 -2.11,2.527 -3.394,1.379l-34.875,-33.906Zm-27.976,-69.527c-17.208,0.163 -33.355,13.173 -36.934,30.111c-2.634,12.469 1.515,26.166 10.639,35.073c10.478,10.228 27.063,13.662 40.897,8.005c16.003,-6.542 26.182,-25.034 23.007,-42.148c-3.147,-16.967 -18.86,-30.64 -36.627,-31.035c-0.328,-0.005 -0.655,-0.007 -0.982,-0.006Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch2);
export default __webpack_public_path__ + "static/media/search2.707473d6f78e01181cac9b66ae04b263.svg";
export { ForwardRef as ReactComponent };